'use client'

import type { ReactNode } from 'react'

type Props = {
  children: ReactNode
  /** When true, period controls stick below the portal top nav while scrolling. */
  sticky?: boolean
}

/**
 * Date-range toolbar wrapper — sticky positioning on the standalone portal only.
 */
export function SigmaPeriodBar({ children, sticky }: Props) {
  if (!sticky) return <>{children}</>
  return <div className="sigma-dashboard-period-sticky">{children}</div>
}
